import Container from 'components/Containers/Container';
import Users from 'modules/Administration/components/Users';

export default () => {
 
  return (
    <Container name='Quản lý người dùng' parentName='Administration'>
      <Users />
    </Container>
  );
};
